import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MenubarModule } from 'primeng/menubar';
import { CheckboxModule } from 'primeng/checkbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ChipModule } from 'primeng/chip';
import { BadgeModule } from 'primeng/badge';
import { PasswordModule } from 'primeng/password';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoFocusModule } from 'primeng/autofocus';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ChipsModule } from 'primeng/chips';
import { BlockUIModule } from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SkeletonModule } from 'primeng/skeleton';
import { CardModule } from 'primeng/card';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { KnobModule } from 'primeng/knob';
import { CarouselModule } from 'primeng/carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MenuModule } from 'primeng/menu';
import { ProgressBarModule } from 'primeng/progressbar';
import { SpeedDialModule } from 'primeng/speeddial';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ToastModule } from 'primeng/toast';
import { EditorModule } from 'primeng/editor';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { GalleriaModule } from 'primeng/galleria';
import { SplitButtonModule } from 'primeng/splitbutton';
import { PaginatorModule } from 'primeng/paginator';
import { RatingModule } from 'primeng/rating';
import { SliderModule } from 'primeng/slider';
import { StepperModule } from 'primeng/stepper';
import { MeterGroupModule } from 'primeng/metergroup';
import { ChartModule } from 'primeng/chart';
const m = [
  FormsModule,
  ReactiveFormsModule,
  ChartModule,
  ButtonModule,
  SidebarModule,
  DynamicDialogModule,
  DialogModule,
  ConfirmDialogModule,
  InputTextModule,
  DropdownModule,
  InputNumberModule,
  MenubarModule,
  CheckboxModule,
  BreadcrumbModule,
  MessageModule,
  MessagesModule,
  ChipModule,
  BadgeModule,
  PasswordModule,
  MultiSelectModule,
  ChipsModule,
  BlockUIModule,
  CalendarModule,
  TooltipModule,
  InputTextareaModule,
  AutoFocusModule,
  InputSwitchModule,
  AvatarModule,
  AvatarGroupModule,
  SkeletonModule,
  CardModule,
  OverlayPanelModule,
  KnobModule,
  CarouselModule,
  AutoCompleteModule,
  TableModule,
  TabViewModule,
  AccordionModule,
  SelectButtonModule,
  MenuModule,
  ProgressBarModule,
  SpeedDialModule,
  PanelMenuModule,
  ToastModule,
  EditorModule,
  RadioButtonModule,
  InputGroupModule,
  InputGroupAddonModule,
  GalleriaModule,
  SplitButtonModule,
  PaginatorModule,
  RatingModule,
  SliderModule,
  StepperModule,
  SliderModule,
  MeterGroupModule,
];

@NgModule({
  declarations: [],
  imports: m,
  providers: [DialogService],
  exports: m,
})
export class PrimeModule {}
